import { Key } from "lucide-react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import Usuario from "../../model/Usuario";
import UsuarioService from "../../service/administracao/UsuarioService";
import { useToastContext } from "../../provider/ToastContext";

type Props = {
    visible: boolean;
    onHide: () => void;
    usuario: Usuario | null;
    onConfirm: () => void;
}

const usuarioService = new UsuarioService();
export default function ResetSenhaDialog({ visible, onHide, usuario, onConfirm }: Props) {

    const { msgErro } = useToastContext();

    const handleConfirm = () => {
        usuarioService.resetarSenha(usuario?.id||0).then(() => {
            onConfirm();
        }).catch((error) => {
            msgErro("Erro ao resetar a senha", error?.data?.message || "Erro desconhecido");
        });
    }

    return (
        <Dialog
            header="Confirmar Reset de Senha"
            visible={visible}
            style={{ width: "450px" }}
            onHide={() => onHide()}
            footer={
                <div>
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        outlined
                        className="p-button-text"
                        onClick={() => onHide()}
                    />
                    <Button
                        label="Confirmar"
                        icon="pi pi-check"
                        onClick={() => handleConfirm()}
                    />
                </div>
            }
        >
            {usuario && (
                <div className="flex flex-column gap-3">
                    <div className="flex align-items-center gap-2">
                        <Key size={20} className="text-muted" />
                        <p className="m-0">
                            Tem certeza que deseja resetar a senha do usuário?
                        </p>
                    </div>
                    <div
                        className="p-3 border-round"
                        style={{ background: "var(--surface-100)" }}
                    >
                        <p className="m-0 mb-2">
                            <strong>Nome:</strong> {usuario.nome}
                        </p>
                        <p className="m-0 mb-2">
                            <strong>CPF:</strong> {usuario.cpf}
                        </p>
                        <p className="m-0">
                            <strong>Email:</strong> {usuario.email}
                        </p>
                    </div>
                    <p className="text-muted m-0" style={{ fontSize: "0.875rem" }}>
                        Uma nova senha temporária será gerada e enviada para o email do
                        usuário.
                    </p>
                </div>
            )}
        </Dialog>
    )
}